import { IEnvConfig } from '../types/IEnvConfig'
import ConfigData from '../configs/config.json'

declare global {
    interface Window { _env_: any; }
}
 
export const getEnviornmentConfig = (): IEnvConfig => {
	const kongApiKey : string = window._env_.REACT_APP_KONG_API_KEY ?? process.env.REACT_APP_KONG_API_KEY;
	const appVersion : string = window._env_.REACT_APP_VERSION ?? process.env.REACT_APP_VERSION;
	const envName : string = window._env_.REACT_APP_ENV ?? process.env.REACT_APP_ENV;
	let domain = window.location.host?.toLowerCase();
	let confDataFromJson = ConfigData.find(k=>k.value.HOST.toLowerCase() === domain)?.value;
	if(!confDataFromJson)
	{
		//first one is default
		confDataFromJson = ConfigData[0].value;
	}
	return{
		authUrl: confDataFromJson.AUTHURL,
		clientId: confDataFromJson.CLIENTID,
		clientUrl: confDataFromJson.SERVER_URL,
		serverUrl: confDataFromJson.SERVER_URL,
		apiKey: kongApiKey,
		apiUrl: confDataFromJson.APIURL,
		appVersion: appVersion,
		envName: envName,
		instrumentationKey: confDataFromJson.INSTRUMENTATIONKEY
	} ;
	
}

export const isLocalHost = () => {
	return getEnviornmentConfig().envName === "LOCAL";
}

export const ENV = getEnviornmentConfig()